import React, { Component } from "react";
import { connect } from "react-redux";

// Components
import TrainingEducationItem from "./TrainingEducationItem";

class SearchTrainingEducation extends Component {
	render() {
		const { translations } = this.props;

		return (
			<div>
				{this.props.items.length ? (
					this.props.items.map((item, i) => <TrainingEducationItem key={i} item={item} />)
				) : (
					<div>{translations.sections.training_education.no_results_response}</div>
				)}
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		translations: state.translations.translations
	};
};

export default connect(mapStateToProps)(SearchTrainingEducation);



// WEBPACK FOOTER //
// ./src/components/training/education/SearchTrainingEducation.js